<template>
  <div>
    <!--#region -- Header ---->

    <div>
      <div v-if ="reportAccess()" class="caption-label">
        <span class="mr-2">{{ function_name }} </span>
        <a class="btn btn-primary" target="_blank" :href="safeUrl(`${frontEndUrlToUse}ftie/ftie-dashboard`)">List View</a>
        <a class="btn btn-primary" target="_blank" :href="safeUrl(`${$root.frontEndUrl}/custom-level-report`)" style="margin-left:10px ;">Custom Level Report</a>
      </div>
      <div v-else>
        <span class="mr-2">{{ function_name }} </span>
        <a class="btn btn-primary" target="_blank" :href="safeUrl(`${frontEndUrlToUse}ftie/ftie-dashboard`)">List View</a>
      </div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-4">
              <div class="label mt-2">Ticket Status</div>
              <div class="row">
                <div class="col-6">
                  <div class="sub-label">Ticket Status:</div>
                  <gtc-multi-select v-model="ticket_status" key-field="value" text-field="text"
                                    :options="ticket_status_options" select-class="w-100"></gtc-multi-select>
                </div>

              </div>
              <div class="label mt-2">Model & Type</div>
              <div class="row">
                <div class="col-6">
                  <div class="sub-label">Model:</div>
                  <gtc-multi-select v-model="model" key-field="value" text-field="text"
                                    :options="model_options" select-class="w-100" class="w-100"></gtc-multi-select>
                </div>
                <div class="col-6">
                  <div class="sub-label">Type:</div>
                  <gtc-multi-select v-model="ticket_type" key-field="value" text-field="text"
                                    :options="ftieTypeOptions" select-class="w-100"></gtc-multi-select>
                  <!--<b-form-select v-model="ticket_type" :options="ticket_type_options" label="GTC Owner:"></b-form-select>-->
                  <!-- FROM :options="ticket_type_options" TO :options="ftieTypeOptions" -->
                </div>
              </div>

            </div>
            <div class="col">
              <div class="label mt-2">Owner</div>
              <div class="row">
                <div class="col-3">
                  <div class="sub-label">GRO Site:</div>
                  <b-form-select v-model="GRO" :options="GRO_options" label="GRO Site:"></b-form-select>
                </div>
                <div class="col-3">
                  <div class="sub-label">GRO Owner (L1):</div>
                  <div v-if="GROOwnerList.length == 0">
                    <b-form-input v-model="GRO_owner" placeholder="" label="GRO Owner:" trim></b-form-input>
                  </div>
                  <div v-else>
                    <b-form-select v-model="GRO_owner" :options="GROOwnerList" label="GRO Owner:"></b-form-select>
                  </div>
                </div>
                <div class="col-3">
                  <div class="sub-label">GTC Owner (L2):</div>
                  <div v-if="GTCOwnerList.length == 0">
                    <b-form-input v-model="GTC_owner" placeholder="" label="GTC Owner:" trim></b-form-input>
                  </div>
                  <div v-else>
                    <b-form-select v-model="GTC_owner" :options="GTCOwnerList" label="GTC Owner:"></b-form-select>
                  </div>
                </div>
                <div class="col-3"><div class="sub-label"></div></div>
              </div>
              <div class="label mt-2">Search</div>
              <div class="row">
                <!--<div class="col-3">
                  <div class="sub-label">Model:</div>
                  <gtc-multi-select v-model="model" key-field="value" text-field="text"
                                    :options="model_options" select-class="w-100" class="w-100"></gtc-multi-select>
                </div>-->
                <div class="col-6">
                  <div class="sub-label">FTIE Create Date:</div>
                  <div class="d-flex">
                    <input type="text" class="form-control" v-model="date_from" v-datepicker:to="date_to" />
                    <span class="font-weight-bold align-self-center">～</span>
                    <input type="text" class="form-control" v-model="date_to" v-datepicker:from="date_from" />
                  </div>
                </div>
                <div class="col-3">
                  <div class="sub-label">Customer:</div>
                  <b-form-input v-model="customer"
                                placeholder=""
                                label="Customer"
                                trim>
                  </b-form-input>
                </div>
                <div class="col-3">
                  <div class="sub-label">Keywords:</div>
                  <b-form-input v-model="keywords"
                                placeholder=""
                                label="Keywords:"
                                trim>
                  </b-form-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-auto align-self-end" style="width: 11.5rem">
          <b-button @click="search()" variant="primary">Search</b-button>
          <!--
              <b-button @click="resetFilterCondition()" variant="btn btn-outline-primary">Reset</b-button>
  -->

        </div>
      </div>
    </div>

    <!--#endregion -- Header ---->
    <!--#region -- Body ---->

    <div class="mt-3" v-if="already_first_search_flag==true">

      <!--#region -- Result Count ---->

      <div class="d-flex">
        <div class="h5 font-weight-bold mt-2">{{ rows }} Results</div>
        <div class="ml-2">
          <b-pagination v-model="currentPage"
                        :total-rows="rows"
                        per-page=1
                        :disabled="pageDisabled"
                        :limit="pageLimit"
                        @change="pageChange">
          </b-pagination>
        </div>
      </div>

      <!--#endregion -- Result Count ---->
      <!-- fix IE Browser min-height: 2.5rem -->
      <div class="table-responsive" style="min-height: 2.5rem">
        <b-table :fields="fields" :items="searchedData"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(ftie_id)="data">
            <gtc-ftie-page v-if="data.item!=null" :prop_ftie_page_obj="data.item" :prop_user_sites="userSites" :prop_user="login_user_name" :prop_user_roles="userRoles"/>
          </template>
        </b-table>
      </div>
    </div>

    <!--#endregion -- Body ---->

  </div>

</template>

<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'ftie-page-dashboard',
    data() {
      return {
        function_name: 'FTIE Ticket Page Tracking',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        keywords: '',
        customer: '',
        authUrl: '',
        frontendUrl: '',
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        userInfo: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        date_from: '',
        date_to: '',
        GRO_options_default: '',
        GRO_options: [
          { value: '', text: 'ALL' },
          { value: 'GDE', text: 'GDE' },
          { value: 'Getac', text: 'Getac' },
          { value: 'GFR', text: 'GFR' },
          { value: 'GMD-AFME', text: 'GMD-AFME' },
          { value: 'GMD-AU', text: 'GMD-AU' },
          { value: 'GMD-E.ASIA', text: 'GMD-E.ASIA' },
          { value: 'GMD-IN', text: 'GMD-IN' },
          { value: 'GMD-IT', text: 'GMD-IT' },
          { value: 'GMD-LATAM', text: 'GMD-LATAM' },
          { value: 'GMD-CISCEE', text: 'GMD-CISCEE' },
          { value: 'GMD-S.ASIA', text: 'GMD-S.ASIA' },
          { value: 'GMD-W.EU', text: 'GMD-W.EU' },
          { value: 'GML', text: 'GML' },
          { value: 'GTK', text: 'GTK' },
          { value: 'GUK', text: 'GUK' },
          { value: 'GUSA', text: 'GUSA' },
          { value: 'OTHERS', text: 'OTHERS' },
        ],
        GRO: '',
        GROText: '',
        GTCOwnerList: [],
        GROOwnerList: [],
        model_options: [],
        ftieTypeList: [],
        ftieTypeOptions: [],
        model: '',
        loadingCnt: 0,

        my_status_options: [{ value: 'InProgress', text: 'In Progress' }, { value: 'Oncoming', text: 'Oncoming' }],
        my_status: '',

        NRE_status_options: [],
        NRE_status: [{ value: 'Waiting', text: 'Ongoing' }, { value: 'W', text: 'Awaiting' }],

        //ticket_type_options: ['ALL', 'Pre-sales', 'Post-sales', 'Customization Support', 'Sector Solution'],
        ticket_type_options: [
        { value: '3rd Party Solution', text: '3rd Party Solution' },
        { value: 'Customization Support', text: 'Customization Support' },
        { value: 'Development Documents', text: 'Development Documents' },
        { value: 'Technical Inquiry', text: 'Technical Inquiry' },
        { value: 'Technical Issue', text: 'Technical Issue' },
        { value: 'Technical Support', text: 'Technical Support' }],
        ticket_type: '',

        ticket_status_options: [{ value: 'New', text: 'New' }, { value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }],
        ticket_status: [{ value: 'New', text: 'New' }, { value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }],

        reason_text: null,

        already_first_search_flag: false,
        fields: [
          { key: 'ftie_id', label: 'FTIE ID', thClass: 'align-middle', thStyle: { display:'None' }, sortable: false }
        ],
        searchByFtieId: null,
        searchedData: [],
        GRO_owner: '',
        GTC_owner: 'ALL',
        login_user_name: '',
        searching: false,
        pageDisabled: false,
        pageLimit: 10,
        perPage: 1,
        currentPage: 1,
        totalCount: '',

      }
    },
    created() {
      let self = this;
    },
    computed: {
      rows() {
        return this.totalCount
        //return this.searchedData.length
      },
      date_from_computed() {
        let str = moment(this.date_from, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      },
      date_to_computed() {
        let str = moment(this.date_to, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      }
    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.loadingCnt = 0;
      this.get_ftie_owner_list();
      if (this.$route.params.ftieId) {
        //this.keywords = this.$route.params.keywords;
        this.searchByFtieId = this.$route.params.ftieId;
        console.log("this.searchByFtieId = ");
        console.log(this.searchByFtieId);
        this.search();
      }
    },
    methods: {
      reportAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        if ((user_site && _.indexOf(user_site, 'Getac') > -1) && (
          (user_roles && _.indexOf(user_roles, 'Admin') > -1)
          || (user_functions && _.indexOf(user_functions, 'ES PM Leader') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM') > -1)
          || (user_roles && _.indexOf(user_roles, 'HQ_ES') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM_Leader') > -1)
        )
        ) {
          console.log("Access to report!");
          return true
        }
        return false;
      },
      get_ftie_owner_list() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/get-ftie-owners';

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let gtc_owner_list = [];
        let gro_owner_list = [];
        self.$axios.get(url, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              gtc_owner_list = JSON.parse(res['gtc_owner_list']);
              gro_owner_list = JSON.parse(res['gro_owner_list']);
              self.GTCOwnerList = gtc_owner_list;
              self.GTCOwnerList.unshift('ALL');

              self.GROOwnerList = gro_owner_list;
              self.GROOwnerList.unshift('ALL');
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            if ((self.userSites && _.indexOf(self.userSites, 'Getac') > -1)) {
              if (self.GTCOwnerList && _.indexOf(self.GTCOwnerList, self.login_user_name) > -1) {
                self.GTC_owner = self.login_user_name;
              }
              else {
                self.GTC_owner = 'ALL';
              }
            }
            self.GRO_owner = 'ALL';
            //self.search();
            eventHub.$emit('loading', false);
          });
      },
      setDefaultDateForSearching() {
        console.log("setDefaultDateForSearching");
        let self = this;
        //let today = moment();
        let defaultStartDate = moment().subtract(2, 'months');
        self.date_from = defaultStartDate.format('YYYY-MMM-DD');
        self.date_to = moment().format('YYYY-MMM-DD');
      },

      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location = self.frontEndUrlToUse + 'azure-login';
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);


        this.login_user_name = user_name;
        //this.GTCOwnerList = options.gtc_owner_opt_list;
        this.GROOwnerList = options.gro_owner_opt_list;
        this.ownerSelectionDic = options.owner_dic_with_region_key;
        this.ftieTypeList = options.ftie_type_list;
        console.log("options.ftie_type_list:");
        console.log(options.ftie_type_list);
        console.log("options.gtc_owner_default:");
        console.log(options.gtc_owner_default);
        console.log("options.gro_owner_default:");
        console.log(options.gro_owner_default);

        //this.GTC_owner = options.gtc_owner_default;
        //this.GRO_owner = options.gro_owner_default;

        //console.log("GTCOwnerList:");
        //console.log(this.GTCOwnerList);
        //console.log("GROOwnerList:");
        //console.log(this.GROOwnerList);

        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
        var i;
        var model_option_new = new Array();
        for (i = 0; i < options.model_list.length; i++) {
          model_option_new.push({ value: options.model_list[i], text: options.model_list[i] })
        }
        this.model_options = this.model_options.concat(model_option_new);

        var ticketTypeOptionTmp = new Array();
        for (i = 0; i < options.ftie_type_list.length; i++) {
          ticketTypeOptionTmp.push({ value: options.ftie_type_list[i], text: options.ftie_type_list[i] })
        }
        this.ftieTypeOptions = this.ftieTypeOptions.concat(ticketTypeOptionTmp);
      },
      search() {
        if (this.loadingCnt == 0) {
          this.already_first_search_flag = false;
          this.loadingCnt = this.loadingCnt + 1;
        }
        this.currentPage = 1;
        this.getFties();
      },
      pageChange(page) {
        this.currentPage = page
        this.getFties() // api call
      },
      perPageChange() {
        this.currentPage = 1;
        this.getFties() // api call
      },
      getFties() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/list/';
        console.log('####getFties######');
        var model_selected = [];
        var ticket_type_selected = [];
        var ticket_status_selected = [];
        var my_status_selected = [];
        var i;
        if (self.model.length == 0) {
          model_selected.push("")
        } else {
          for (i = 0; i < self.model.length; i++) {
            model_selected.push(self.model[i]['value'])
          }
        }

        if (self.ticket_status.length == 0) {
          ticket_status_selected.push("")
        }
        else {
          for (i = 0; i < self.ticket_status.length; i++) {
            ticket_status_selected.push(self.ticket_status[i]['value'])
          }
        }

        if (self.ticket_type.length == 0) {
          ticket_type_selected = ['']
        }
        else {
          for (i = 0; i < self.ticket_type.length; i++) {
            ticket_type_selected.push(self.ticket_type[i]['value'])
          }
        }

        let request_data = {
          model_selected: model_selected,
          ticket_type_selected: ticket_type_selected,
          ticket_status_selected: ticket_status_selected,
          /*my_status_selected: my_status_selected,*/
          record_per_page: self.perPage,
          page_index: self.currentPage,
          GRO: self.GRO,
          GRO_owner: self.GRO_owner,
          GTC_owner: self.GTC_owner,
          date_from: self.date_from_computed,
          date_to: self.date_to_computed,
          keywords: self.keywords,
          customer: self.customer,
          search_by_ftie_id: self.searchByFtieId,
          search_type: 'Page'
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        //let nreTotalCount = 2;
        let totalCount = 0;

        if (self.already_first_search_flag == false) {
          eventHub.$emit('loading', true);
        }
         self.$axios.post(url, request_data, { params })
           .then((response) => {
             var res = response.data;
             //console.log(res);

             if (response.status === 200) {
               searchedData = JSON.parse(res['ftie_list']);
               totalCount = parseInt(searchedData[0].total_count);
               //console.log(searchedData);
             }

             else if (response.status === 204) {
               self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
               console.log(res.description);
             }

             else if (res.description == "login") {
               self.$session.destroy();
               self.$store.commit('clearToken');
               var url = self.$root.baseUrl + '/auth/logout/';
               self.$axios.get(url)
                 .then((res) => {
                   console.log('logout');
                   self.$router.push("/");
                 })
               window.location = self.frontEndUrlToUse + 'azure-login';
             } else {
               self.$message.exception('Internal Server Error!');
               console.log(res.description);
               //console.log(res['msg'])
             }
           }, (error) => {
             console.log(error);
             self.$message.exception('Internal Server Error!');
           })
           .finally(() => {
             self.searching = false;
             self.already_first_search_flag = true;
             if (self.already_first_search_flag == true) {
               eventHub.$emit('loading', false);
             }
             self.searchedData = searchedData;
             self.totalCount = totalCount;
           })
      },
      resetFilterCondition() {
        let self = this;
        self.keywords = '';
        self.my_status = [];
        self.model = '';
        //self.GRO = '';
        self.GRO_owner = 'ALL';
        self.GTC_owner = 'ALL';
        self.date_from = '';
        self.date_to = '';
        //self.NRE_status = [{ value: 'Waiting', text: 'Ongoing' }, { value: 'W', text: 'Awaiting' }];//{Ongoing, Waiting}
        self.NRE_status = [{ value: "Waiting", text: "Ongoing" }, { value: "W", text: "Awaiting" }, { value: "Completed", text: "Completed" }, { value: "Rejected", text: "Rejected" }, { value: "Deferred", text: "Deferred" }];
        self.ticket_status = [{ value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }]; //{Open, Solved, Closed, Deferred}
        self.my_status = [];
        if (self.searchByFtieId !== null) {
          self.searchByFtieId = null;
          self.$router.push('/ftie/ftie-page-dashboard');
        }
        self.searchByFtieId = null;
      },
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/_FTIEPageDashboard.vue